module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Accordion.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Accordion.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Accordion.vue
 ** module id = 78
 ** module chunks = 0
 **/